import React from "react";
import { Calendar, LayoutGrid, Settings, FileText, CheckCircle2, Activity, LogOut, HelpCircle } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutGrid, activeColor: 'bg-blue-600', testid: 'nav-dashboard' },
  { key: 'admin', label: 'Admin', icon: Settings, activeColor: 'bg-purple-600', testid: 'nav-admin' },
  { key: 'visits', label: 'Visits', icon: Calendar, activeColor: 'bg-green-600', testid: 'nav-visits' },
  { key: 'reports', label: 'Reports', icon: FileText, activeColor: 'bg-orange-600', testid: 'nav-reports' },
  { key: 'qc', label: 'QC Dashboard', icon: CheckCircle2, activeColor: 'bg-teal-600', testid: 'nav-qc-dashboard' },
  { key: 'ops', label: 'Ops Dashboard', icon: Activity, activeColor: 'bg-indigo-600', testid: 'nav-ops-dashboard' },
];

export const AppHeader = ({ currentPage, setCurrentPage, user, isAdmin, logout, onHelpClick, headerActions }) => (
  <header className="bg-white shadow-lg border-b-2 border-blue-600">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center py-4">
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-3">
            <img src="/birdy-logo.png" alt="Stryde Ops" className="h-10 w-auto object-contain" />
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent whitespace-nowrap">Stryde Ops</h1>
              <p className="text-xs text-gray-500 whitespace-nowrap">Clinical Research Management</p>
            </div>
          </div>
          <nav className="hidden md:flex space-x-2 bg-gray-100 rounded-lg p-1">
            {NAV_ITEMS.map(({ key, label, icon: Icon, activeColor, testid }) => (
              <Button
                key={key}
                variant={currentPage === key ? "default" : "ghost"}
                onClick={() => setCurrentPage(key)}
                className={`flex items-center gap-2 ${currentPage === key ? `${activeColor} text-white shadow-md` : "hover:bg-white"}`}
                size="sm"
                data-testid={testid}
              >
                <Icon className="h-4 w-4" /> {label}
              </Button>
            ))}
          </nav>
        </div>

        <div className="flex items-center space-x-4">
          {headerActions}
          <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-200">
            <Button variant="ghost" size="sm" onClick={onHelpClick} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50" title="Help & FAQ" data-testid="help-btn">
              <HelpCircle className="h-4 w-4" />
            </Button>
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{user?.name}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
              {isAdmin && <Badge variant="secondary" className="text-xs">Admin</Badge>}
            </div>
            <Button variant="outline" size="sm" onClick={logout} className="flex items-center gap-2" data-testid="logout-btn">
              <LogOut className="h-4 w-4" /> Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  </header>
);
